import { createActions } from 'redux-actions';

export const { loadExportCompanies, loadedExportCompanies, errorExportCompanies, closeExportCompanies } = createActions(
  'LOAD_EXPORT_COMPANIES',
  'LOADED_EXPORT_COMPANIES',
  'ERROR_EXPORT_COMPANIES',
  'CLOSE_EXPORT_COMPANIES',
);
